(() => {
  if (window.sesseqFavoritesReady) return;
  window.sesseqFavoritesReady = true;
  const key = 'sesseq.favorites.v1';
  const dialog = document.getElementById('sesseq-favorites');
  if (!dialog) return;
  const list = dialog.querySelector('[data-favorites-list]');
  const empty = dialog.querySelector('[data-favorites-empty]');
  const status = document.getElementById('sesseq-favorites-status');
  let opener;
  let items = [];
  const validURL = (value) => {
    try { const url = new URL(value, location.origin); return url.origin === location.origin && /\/products\//.test(url.pathname); } catch { return false; }
  };
  const localizedURL = value => {
    const url = new URL(value, location.origin);
    const productPath = url.pathname.slice(url.pathname.indexOf('/products/'));
    url.pathname = (window.Shopify?.routes?.root || '/').replace(/\/$/, '') + productPath;
    return url.href;
  };
  const read = () => {
    try {
      const stored = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(stored) ? stored.filter(item => item && /^\d+$/.test(item.id) && typeof item.title === 'string' && validURL(item.url)).slice(0,500) : [];
    } catch { return []; }
  };
  items = read();
  const sync = () => {
    const ids = new Set(items.map(item => item.id));
    document.querySelectorAll('[data-favorite-id]').forEach(button => {
      const saved = ids.has(button.dataset.favoriteId);
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', saved ? button.dataset.labelRemove : button.dataset.labelAdd);
    });
    document.querySelectorAll('[data-favorites-count]').forEach(count => {
      if (count.textContent !== String(items.length)) count.textContent = String(items.length);
      count.hidden = items.length === 0;
    });
  };
  const persist = () => {
    try { localStorage.setItem(key, JSON.stringify(items)); }
    catch { status.textContent = dialog.dataset.storageError; }
    sync();
  };
  const element = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  };
  const refreshPrices = async (cards) => {
    const format = new Intl.NumberFormat(document.documentElement.lang || 'nl-BE', {style:'currency',currency:dialog.dataset.currency || 'EUR'});
    let next = 0;
    const worker = async () => {
      while (next < cards.length) {
        const {item, price, link, remove} = cards[next++];
        if (!price.isConnected) continue;
        try {
          const url = new URL(localizedURL(item.url), location.origin);
          url.pathname = url.pathname.replace(/\/$/, '') + '.js';
          url.search = ''; url.hash = '';
          const response = await fetch(url, {headers:{Accept:'application/json'}});
          if (!response.ok) throw new Error('Product unavailable');
          const product = await response.json();
          const parts = product.title.replace(/ [–—] /g,' - ').split(' - ');
          link.querySelector('h3').textContent = parts.shift();
          let subtitle = link.querySelector('p');
          if (parts.length) {
            if (!subtitle) { subtitle = element('p'); price.before(subtitle); }
            subtitle.textContent = parts.join(' - ');
          } else subtitle?.remove();
          const image = link.querySelector('img');
          if (image) image.alt = product.title;
          remove.setAttribute('aria-label', `${dialog.dataset.removeLabel}: ${product.title}`);

          const prices = product.variants.map(variant => Number(variant.price)).filter(value => value > 0);
          if (!prices.length) price.textContent = dialog.dataset.comingSoon;
          else {
            const amount = format.format(Math.min(...prices) / 100);
            price.textContent = product.price_varies ? dialog.dataset.fromPrice.replace('[price]', amount) : amount;
          }
        } catch { price.textContent = dialog.dataset.pricePending; }
      }
    };
    await Promise.all(Array.from({length:Math.min(4,cards.length)}, worker));
  };
  const render = () => {
    const pricesToRefresh = [];
    list.replaceChildren();
    empty.hidden = items.length !== 0;
    items.forEach(item => {
      const card = element('article','sesseq-favorites__card');
      const link = element('a');
      link.href = localizedURL(item.url);
      try {
        const imageURL = new URL(item.image, location.origin);
        if (item.image && imageURL.protocol === 'https:') {
          const image = element('img');
          image.src = imageURL.href; image.alt = item.title; image.loading = 'lazy'; image.width = 600; image.height = 600;
          link.append(image);
        }
      } catch {}
      const title = item.title.replace(/ [–—] /g,' - ').split(' - ');
      link.append(element('h3','',title.shift()));
      if (title.length) link.append(element('p','',title.join(' - ')));
      const price = element('strong','',dialog.dataset.pricePending);
      link.append(price);

      const remove = element('button','',dialog.dataset.removeLabel);
      remove.type = 'button'; remove.dataset.favoriteRemove = item.id;
      remove.setAttribute('aria-label',`${dialog.dataset.removeLabel}: ${item.title}`);
      pricesToRefresh.push({item,price,link,remove});
      card.append(link,remove); list.append(card);
    });
    refreshPrices(pricesToRefresh);
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-favorite-id], [data-favorites-open], [data-favorites-close], [data-favorite-remove]');
    if (!button) return;
    event.preventDefault();
    if (button.hasAttribute('data-favorite-id')) {
      const id = button.dataset.favoriteId;
      const saved = items.some(item => item.id === id);
      if (saved) items = items.filter(item => item.id !== id);
      else if (validURL(button.dataset.favoriteUrl)) items.push({id,title:button.dataset.favoriteTitle,url:button.dataset.favoriteUrl,image:button.dataset.favoriteImage,productType:button.dataset.favoriteProductType});
      persist();
      if (dialog.open) render();
    } else if (button.hasAttribute('data-favorites-open')) {
      opener = button; render(); dialog.showModal(); dialog.scrollTop = 0;
    } else if (button.hasAttribute('data-favorites-close')) dialog.close();
    else {
      const index = items.findIndex(item => item.id === button.dataset.favoriteRemove);
      items = items.filter(item => item.id !== button.dataset.favoriteRemove);
      persist(); render();
      const remaining = list.querySelectorAll('button');
      (remaining[Math.min(index,remaining.length - 1)] || dialog.querySelector('[data-favorites-close]')).focus();
    }
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => opener?.focus({preventScroll:true}));
  window.addEventListener('storage', event => { if (event.key === key || event.key === null) { items = read(); sync(); if (dialog.open) render(); } });
  let queued = false;
  new MutationObserver(records => {
    if (queued || !records.some(record => [...record.addedNodes].some(node => node.nodeType === 1))) return;
    queued = true; queueMicrotask(() => { queued = false; sync(); });
  }).observe(document.body,{childList:true,subtree:true});
  sync();
})();

